import { render, staticRenderFns } from "./TipiMezzoMovimentazione.vue?vue&type=template&id=e264e8c2"
import script from "./TipiMezzoMovimentazione.vue?vue&type=script&lang=js"
export * from "./TipiMezzoMovimentazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports